<template>
	<!-- 我的竞拍 -->
	<div>
		<ul class="list_center_title">
			<li>标的编号</li>
			<li>出价金额</li>
			<!-- <li>货款金额</li> -->
			<li>竞拍时间</li>
			<li>竞拍状态</li>
		</ul>
		<ul class="list_center_text">
			<li v-for="(auction,index) in auctions" :key="index">
			<span>[{{auction.subject_id}}]</span>
			<span>{{auction.price}}</span>
			<!-- <span>{{auction.price}}</span> -->
			<span>{{auction.created_at}}</span>
			<span>{{auction.is_lead==1?'领先':'淘汰'}}</span>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'Auction',
	inject: ['reload'],
	data (){
		return{
			token: localStorage.getItem('apiToken'),
			auctions: []
		}
	},
	created(){
		// 请求页面数据
		// this.axios.get(this.$global.apiUrl.shops_show, {
		// 	params: {
		// 		id: 1
		// 	}
		// })
		// .then((response) => {
		// 	if(response.data.error.code == 0){
		// 		this.auctions = response.data.products;
		// 		console.log(this.auctions);
		// 	}else{

		// 	}
		// })
		// .catch(() => {})

		this.axios.get(this.$global.apiUrl.customer_auctions, {
			params: {
				apiToken: this.token
			}
		})
		.then((response) => {
			if(response.data.error.code == 0){
				this.auctions = response.data.auctions
			}
		})
		.catch(() => {})
	},
	watch:{
		
	},
	mounted(){

	},
	computed: {

	},
	methods: {
		
	}
}
</script>